<template>
    <div class="form-builder">

        <Breadcrumbs :steps="steps" @step="handleStep"></Breadcrumbs>

        <div class="form-builder-steps" :style="{transform: translateForSteps}">
            <Step :ref="'step'+index" v-for="(step,index) in steps" :key="index" :stepIndex="index" :description="step" :tokens="tokens" :configuration="configuration" :class="{disabled:currentStep != index}">
            </Step>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    import {mapGetters} from 'vuex'

    import Step from './Step'
    import Breadcrumbs from './Breadcrumbs'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Step,
            Breadcrumbs
        },
        computed: {
            ...mapGetters({
                currentStep: 'Plugins/currentStep'
            }),
            steps(){
                return this.descriptor.form.steps
            },
            tokens(){
                return this.descriptor.tokens
            },
            translateForSteps(){
                return 'translate(-'+this.currentStep * 100+'%,0)'
            }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            handleStep(index){
                this.$emit('step',index)
            }
        },
        mounted: function () {

        },
        name: '',
        props: {
            descriptor:{
                type: Object,
                required: true
            },
            configuration: {
                type: Object,
                default(){
                    return {}
                }
            }
        },
        updated: function () {

        },
        watch: {
            configuration:{
                deep: true,
                handler(newVal) {
                    //console.log('watch configuration')
                    this.$emit('configurationChanged',newVal)
                }
            }
        }
    }
</script>

<style lang="scss">
    .form-builder{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        //overflow: hidden;

        .form-builder-breadcrumbs{
            flex: 0 0 80px;
            /*position: fixed;
            left: calc(50% + 40px);
            padding: 40px 0 20px;
            margin: 0;
            transform: translate(-50%,-20px);
            background-color: $main-white;
            z-index: 10;*/
        }

        .form-builder-steps{
            width: 100%;
            height: 100%;
            flex: 1 1 100%;
            //margin-top: 120px;
            display: flex;
            flex-wrap: nowrap;

            //transform: translate(-100%,0);


            .form-builder-step{
                flex: 0 0 100%;
                //overflow: auto;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/FormBuilder.vue